// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }: any) =>
  theme.custom.widgets.sidenav.drawerRoot(ownerState)
);
